import { defineStore } from 'pinia';
import api from '@/api';
import { useUserStore } from "./user";

export const useCustomAuthRoleGroupsStore = defineStore('customAuthRoleGroups', {
  state: () => ({
    allDict: {},
    loading: false,
    dropdownOptions: [],
  }),
  getters: {
    allRoleGroups: (state) => Object.values(state.allDict),
  },
  actions: {
    async fetchAll() {
      try {
        this.loading = true;
        const userStore = useUserStore()
        const organization_id = userStore.authUserOrganizationId
        const res = await api.role.fetchAll(organization_id);
        this.allDict = res.data.reduce((dict, roleGroup) => {
          dict[roleGroup.group_ptr_id] = roleGroup;
          return dict;
        }, {});

        this.dropdownOptions = Object.values(this.allDict).map((role) => {
          return {
            text: role.name,
            value: role.group_ptr_id,
          };
        });
        
      } catch (error) {
        console.error(error.message);
      } finally {
        this.loading = false;
      }
    },
    getIdFromCode(roleCode) {
      for (const roleId in this.allDict) {
        if (this.allDict[roleId].code === roleCode) return roleId;
      }
      return undefined;
    },
  },
});
